const ImagePath = "/assets/images";
export const AppImages = {
  logoIcon: `${ImagePath}/JOBO.png`,
  logoIconDark: `${ImagePath}/JOBO.png`,
  noData: `${ImagePath}/no_data_available.png`,
};

const SVGPath = "/assets/svg";
export const AppSVG = {
  logoIcon: `${SVGPath}/logo.svg`,
  googleIcon: `${SVGPath}/google.svg`,
  appleIcon: `${SVGPath}/apple.svg`,
};

const IconsPath = "/assets/icons";
export const AppIcons = {
  addIcon: `${IconsPath}/icn_add_rounded.svg`,
  calenderIcon: `${IconsPath}/icn_calender.svg`,
  avatarIcon: `${IconsPath}/avatar.svg`,
};

// Add as per needed
